import { ValidationObserver } from "vee-validate/dist/vee-validate.full";
import BInput from "@/components/singles/BInput/component.vue";

export default {
  name: "EditableText",
  components: {
    ValidationObserver,
    BInput,
  },
  props: [
    "label",
    "type",
    "validation",
    "value",
    "icon",
    "placeholder",
    "css",
    "page",
    "saveFunc",
  ],
  computed: {
    friendlyValue() {
      if (
        this.value &&
        !this.$store.state.auth.success &&
        this.value.value &&
        this.value.value.toLowerCase() == "text saknas"
      ) {
        return "";
      } else if (
        this.value &&
        !this.value.value &&
        this.$store.state.auth.role.level <= 2
      )
        return "Text saknas";
      else return this.value.value;
    },
  },
  data() {
    return {
      edit: false,
      originalValue: String,
      name: null,
    };
  },
  created() {},
  mounted() {
    if (
      (!this.value.value || this.value.value == "") &&
      this.$store.state.auth.success
    ) {
      this.value.value = "Text saknas";
    }
  },
  methods: {
    Edit() {
      if (this.$store.state.auth.role.level <= 2) {
        this.name = Math.random()
          .toString(36)
          .substring(7);
        this.originalValue = this.value.value;
        this.edit = !this.edit;
      }
    },

    UpdateValue(event) {
      this.$emit("input", { ...this.value, value: event });
    },
    async Cancel() {
      this.$emit("cancel");
      this.$emit("input", { ...this.value, value: this.originalValue });
      this.$helpers.ShowStatus("Avbrutet.", 3000);
      this.edit = false;
    },
    async Save(value) {
      let valid = await this.$refs.observer.validate();

      if (this.edit && valid) {
        this.SaveChange(value);
      } else {
        this.$helpers.ShowStatus(`Inte sparat.`, 3000, "warning");
        this.$emit("input", { ...this.value, value: this.originalValue });
      }

      this.edit = !this.edit;
    },
    async SaveChange(value) {
      this.isLoading = true;

      if (this.originalValue != value) {
        try {
          if (this.saveFunc) {
            await this.saveFunc();
          } else {
            await this.$helpers.SetField(this.page, this.value.name, value);
          }

          this.$helpers.ShowStatus("Sparat.", 3000);
          this.$emit("input", { ...this.value, value: value });
        } catch {}
      } else {
        this.$helpers.ShowStatus("Inget ändrat, sparar inte.", 3000);
      }

      this.isLoading = false;
      this.editMode = false;
    },
  },
};
